<div class="confirmation-modal">
  <button type="button" [mat-dialog-close]="false" class="close-button" aria-label="Close dialog">
    <mat-icon svgIcon="delete" class="close-icon"></mat-icon>
  </button>

  <div class="modal-content">
    <h2 id="modal-title" class="modal-title">{{ data.title }}</h2>

    @if (data.subtitle) {
      <h3 id="modal-subtitle" class="modal-subtitle">{{ data.subtitle }}</h3>
    }

    @if (data.message) {
      <p id="modal-message" class="modal-message">{{ data.message }}</p>
    }
  </div>

  <div class="modal-actions">
    <app-action-button
      [mat-dialog-close]="true"
      [label]="confirmLabel"
      icon="arrow-right"
      type="button"
    />
    <app-action-button
      theme="light"
      [mat-dialog-close]="false"
      [label]="cancelLabel"
      type="button"
    />
  </div>
</div>
